module.exports = "/assets/a9591781f7a353e836d71705348de46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WA.png
// module id = 1953
// module chunks = 0